export default "__VITE_ASSET__PUVARZCm__";